package nl.astraeus.wiki.view

import kotlinx.html.classes
import kotlinx.html.div
import kotlinx.html.h3
import kotlinx.html.hr
import kotlinx.html.js.onClickFunction
import nl.astraeus.css.properties.*
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.wiki.css.Css
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssId
import nl.astraeus.wiki.css.CssName

enum class ModalSize {
  EXTRA_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
}

abstract class Modal(
  val title: String,
) : Komponent() {

  abstract val confirmListener: () -> Unit

  open val size: ModalSize = ModalSize.MEDIUM
  open val isModal: Boolean = true
  open val closeListener: () -> Unit = {}
  open val confirmText: String = "Confirm"
  open val cancelText: String = "Cancel"
  open val showCancelButtons: Boolean = true

  fun close() {
    closeListener.invoke()

    this.element?.remove()
  }

  abstract fun HtmlBuilder.renderContent()

  override fun HtmlBuilder.render() {
    div(ModalCss.name) {
      div(ModalBodyCss.name) {
        classes += when (size) {
          ModalSize.EXTRA_SMALL -> ModalExtraSmallCss.name
          ModalSize.SMALL -> ModalSmallCss.name
          ModalSize.MEDIUM -> ModalMediumCss.name
          ModalSize.LARGE -> ModalLargeCss.name
        }
        div(ModalHeaderCss.name) {
          div(ModalTitleCss.name) {
            h3 {
              +title
            }
            if (showCancelButtons) {
              div("${MainView.AddCss.name} ${MainView.HeaderButtonCss.name}") {
                +"Close"

                onClickFunction = {
                  close()
                }
              }
            }
          }
          hr {}
          div(ModalContentCss.name) {
            renderContent()
          }
        }
        div(ModalFooterCss.name) {

          hr {}

          div(ModalFooterButtonsCss.name) {
            if (showCancelButtons) {
              div("${MainView.AddCss.name} ${ModalButtonCss.name}") {
                +cancelText

                onClickFunction = {
                  close()
                }
              }
            }
            div("${MainView.AddCss.name} ${ModalButtonCss.name}") {
              +confirmText

              onClickFunction = {
                confirmListener()
              }
            }
          }
        }
      }

      if (!isModal && showCancelButtons) {
        onClickFunction = {
          close()
        }
      }
    }
  }

  companion object ModalCssObj : CssId("modal") {
    object ModalCss : CssName
    object ModalBodyCss : CssName
    object ModalHeaderCss : CssName
    object ModalContentCss : CssName
    object ModalFooterCss : CssName
    object ModalTitleCss : CssName
    object ModalLargeCss : CssName
    object ModalMediumCss : CssName
    object ModalSmallCss : CssName
    object ModalExtraSmallCss : CssName
    object ModalFooterButtonsCss : CssName
    object ModalButtonCss : CssName

    init {
      defineCss {
        select(ModalCss.cls()) {
          display(Display.flex)
          justifyContent(JustifyContent.center)
          position(Position.fixed)
          zIndex(100)
          left(0.px)
          top(0.px)
          width(100.prc)
          height(100.prc)

          backgroundColor(Css.currentStyle.mainBackgroundColor.changeAlpha(0.75))

          select(ModalBodyCss.cls()) {
            cardCss()

            display(Display.flex)
            flexDirection(FlexDirection.column)
            justifyContent(JustifyContent.spaceBetween)

            position(Position.absolute)

            select(ModalHeaderCss.cls()) {
              select(ModalTitleCss.cls()) {
                display(Display.flex)
                flexDirection(FlexDirection.row)
                justifyContent(JustifyContent.spaceBetween)
              }
            }
            select(ModalContentCss.cls()) {
            }
            select(ModalFooterCss.cls()) {
            }

          }

          select(ModalLargeCss.cls()) {
            top(10.prc)
            width(70.prc)
            height(70.prc)
          }
          select(ModalMediumCss.cls()) {
            top(15.prc)
            width(60.prc)
            height(60.prc)
          }
          select(ModalSmallCss.cls()) {
            top(20.prc)
            width(50.prc)
            height(50.prc)
          }
          select(ModalExtraSmallCss.cls()) {
            top(20.prc)
            width(24.rem)
          }

          select(ModalFooterButtonsCss.cls()) {
            display(Display.flex)
            flexDirection(FlexDirection.row)
            justifyContent(JustifyContent.flexEnd)
            marginTop(1.5.rem)
          }
          select(ModalButtonCss.cls()) {
            padding(0.4.rem, 0.8.rem)
            // add spacing between buttons and from the right edge
            marginLeft(0.6.rem)
          }
        }
      }
    }
  }
}
